import React, { Fragment, useState } from 'react';
import { FaExchangeAlt, FaBan, FaClock } from "react-icons/fa";
import MyConfirmationModal from '../../../components/ConfirmationDialog';
import { LoadingSpinner } from '../../../components';
import goalResultService from '../../../services/goalResultService';
import { setToastMessage } from '../../../reducers/common.reducer';
import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import UpdateEventTimeDialog from './UpdateEventTimeDialog';

const ActionButtonGroup = ({ eventId, IsFivePercentCom, isSingle, isMix, event, userDetails, setEventList }) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [isTimeDialogOpen, setIsTimeDialogOpen] = useState(false);
    const [selectedText, setSelectedText] = useState("");
    const [saveLoading, setSaveLoading] = useState(false);
    const [type, setType] = useState("");
    const [selectedKickoffTime, setSelectedKickoffTime] = useState(null);

    const handleProcess = async (type) => {
        setIsOpen(true);
        setType(type);
        setSelectedText(contentTextMap[type]);
    }

    const handleTimeDialogOpen = () => {
        setType("time");
        setSelectedKickoffTime(null);
        setIsTimeDialogOpen(true);
    }

    const handleTimeDialogClose = () => {
        if (saveLoading) {
            return;
        }

        setIsTimeDialogOpen(false);
        setSelectedKickoffTime(null);
        setType("");
    }

    const handleSubmit = async (kickoffMoment = null) => {
        setSaveLoading(true);
        try {
            if (type === "eight" || type === "five") {
                const response = await goalResultService.updateTaxPercent(type, eventId);
                if (response.status === 200) {
                    dispatch(setToastMessage({ type: "success", message: "Process Successfull!!" }));

                    updateCurrentState(eventId, type);
                }
            }
            else if (type === "time") {
                const nextKickoffTime = kickoffMoment ?? selectedKickoffTime;

                if (!nextKickoffTime || !moment(nextKickoffTime).isValid()) {
                    dispatch(setToastMessage({ type: "error", message: "Please choose a valid kickoff date and time." }));
                    return;
                }

                const payload = {
                    validEventTime: moment(nextKickoffTime).format("YYYY-MM-DDTHH:mm:ss"),
                    rapidEventId: eventId
                }
                const response = await goalResultService.updateEventTime(payload);
                if (response.status === 200) {
                    dispatch(setToastMessage({ type: "success", message: "Kickoff time updated successfully." }));
                    setIsTimeDialogOpen(false);

                    updateCurrentState(eventId, type, nextKickoffTime);
                }
            }
            else {
                const payload = {
                    rapidEventId: eventId,
                    status: await formatStatus(type)
                }
                const response = await goalResultService.removeEvent(payload);
                if (response.status === 200) {
                    dispatch(setToastMessage({ type: "success", message: "Process Successfull!!" }));

                    updateCurrentState(eventId, type);
                }
            }
        } catch (error) {
            dispatch(setToastMessage({ type: "error", message: error?.response?.data?.message || error?.message || "Process failed." }));
        } finally {
            setIsOpen(false);
            setSaveLoading(false);

            if (type !== "time") {
                setType("");
            }
        }
    }

    const formatStatus = async (type) => {
        switch (type) {
            case 'eight':
                return '8%';
            case 'five':
                return '5%';
            case 'freeze_single':
                return 'Single';
            case 'freeze_parlay':
                return 'Mix';
            default:
                return '';
        }
    }

    const updateCurrentState = (eventId, type, nextKickoffTime = null) => {
        const normalizedKickoffTime = moment(nextKickoffTime).format("YYYY-MM-DDTHH:mm:ss");
        if (typeof setEventList === "function") {
            setEventList((currentEvents = []) =>
                currentEvents.map((currentEvent) =>
                    String(currentEvent?.eventId) === String(eventId)
                        ? type === "five" ?
                            {
                                ...currentEvent,
                                isFivePercentCom: true
                            }
                            :
                            type === "eight" ?
                                {
                                    ...currentEvent,
                                    isFivePercentCom: false
                                }
                                :
                                type === "freeze_single" ?
                                    {
                                        ...currentEvent,
                                        isSingle: false
                                    }
                                    : type === "freeze_single" ?
                                        {
                                            ...currentEvent,
                                            isMix: false,
                                        } :
                                        {
                                            ...currentEvent,
                                            startTime: normalizedKickoffTime,
                                            eventTime: normalizedKickoffTime,
                                        }
                        : currentEvent
                )
            );
        }
    }

    return (
        <Fragment>
            {saveLoading ? <LoadingSpinner loading={saveLoading} /> : null}
            <MyConfirmationModal isOpen={isOpen} setIsOpen={setIsOpen} contextText={selectedText} handleSubmit={handleSubmit} isProcessing={saveLoading} />
            <UpdateEventTimeDialog
                open={isTimeDialogOpen}
                onClose={handleTimeDialogClose}
                onSubmit={(kickoffMoment) => {
                    setSelectedKickoffTime(kickoffMoment);
                    handleSubmit(kickoffMoment);
                }}
                event={event}
                isProcessing={saveLoading}
            />
            <div className='mt-2 flex flex-wrap items-center gap-3'>
                {
                    event?.status === "Upcoming" || moment(event?.startTime).isAfter(moment(new Date())) ? isSingle ?
                        <button className='px-3 py-2 min-w-[100px] bg-customAccentBlue dark:bg-gradient-to-r from-customAccent via-customAccent/90 to-customAccent/80 text-customLightMilkWhite text-xs rounded-md flex items-center gap-1 hover:bg-customAccentBlue/90' onClick={() => handleProcess(IsFivePercentCom ? 'eight' : 'five')}>
                            <FaExchangeAlt size={15} /> {IsFivePercentCom === true ? 'Change to 8%' : 'Change to 5%'}
                        </button> : null : null
                }
                {
                    event?.status === "Upcoming" || moment(event?.startTime).isAfter(moment(new Date())) ? isSingle ?
                        <button className='px-3 py-2 bg-customAccentBlue dark:bg-gradient-to-r from-customAccent via-customAccent/90 to-customAccent/80 text-customLightMilkWhite text-xs rounded-md flex items-center gap-1 hover:bg-customAccentBlue/90' onClick={() => handleProcess('freeze_single')}>
                            <FaBan size={15} /> Freeze Single
                        </button> : null : null
                }
                {
                    event?.status === "Upcoming" || moment(event?.startTime).isAfter(moment(new Date())) ? isMix ?
                        <button className='px-3 py-2 bg-customAccentBlue dark:bg-gradient-to-r from-customAccent via-customAccent/90 to-customAccent/80 text-customLightMilkWhite text-xs rounded-md flex items-center gap-1 hover:bg-customAccentBlue/90' onClick={() => handleProcess('freeze_parlay')}>
                            <FaBan size={15} /> Freeze Mix
                        </button> : null : null
                }
                {
                    userDetails.companyId === "LC7" ?
                        <button className='px-3 py-2 bg-customAccentBlue dark:bg-gradient-to-r from-customAccent via-customAccent/90 to-customAccent/80 text-customLightMilkWhite text-xs rounded-md flex items-center gap-1 hover:bg-customAccentBlue/90' onClick={handleTimeDialogOpen}>
                            <FaClock size={15} /> Update KickOff Time
                        </button> : null
                }
            </div>
        </Fragment>
    )
}

export default ActionButtonGroup;

const contentTextMap = {
    "five": "Are you sure you want to change this event to 5% tax?",
    "eight": "Are you sure you want to change this event to 8% tax?",
    "freeze_single": "Are you sure you want to remove this event to single only?",
    "freeze_parlay": "Are you sure you want to remove this event to mix only?",
}
